import { mapCommandCenterActionItems } from 'app/pages/tpoPortal/commandCenterHome/CommandCenterHome/actionItems.utils';
import { brokerActionItemsApi, lockExpiryApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { CommandCenterLoadKey, markCommandCenterLoadedAction } from './loadStatus.actions';

// Broker-facing reads — a 403 (DEV-3647 broker-auth gap) must degrade to the
// empty state, never trigger the global forbidden page-reload loop.
const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

const LOCK_EXPIRY_WINDOW_DAYS = 14;

export const COMMAND_CENTER_ACTION_ITEMS_ACTION_TYPE = createNamedActions(
  'commandCenterActionItems',
  {
    SET_ACTION_ITEMS: 'SET_ACTION_ITEMS',
  },
);

export const getCommandCenterActionItemsAction = catchAsyncActionError(() => async dispatch => {
  try {
    const [{ data: actionItems }, { data: lockExpiry }] = await Promise.all([
      brokerActionItemsApi.getCommandCenterActionItems({ config: SKIP_FORBIDDEN_CONFIG }),
      lockExpiryApi.getExpiringLocks({
        withinDays: LOCK_EXPIRY_WINDOW_DAYS,
        config: SKIP_FORBIDDEN_CONFIG,
      }),
    ]);

    return dispatch({
      type: COMMAND_CENTER_ACTION_ITEMS_ACTION_TYPE.SET_ACTION_ITEMS,
      payload: mapCommandCenterActionItems({
        actionItems: actionItems ?? null,
        lockExpiry: lockExpiry ?? null,
      }),
    });
  } finally {
    dispatch(markCommandCenterLoadedAction(CommandCenterLoadKey.ACTION_ITEMS));
  }
});
